<!-- components/events/yuka/Plan.svelte -->
<script>
  import { t } from "../../../libs/i18n";

  const valueSrc = `assets/img/yukaEvent/value.png`;
  const videoSrc = `assets/img/yukaEvent/video.png`;
  const teacherSrc = `assets/img/yukaEvent/teacher.png`;
  const conversationSrc = `assets/img/yukaEvent/conversation.png`;
  const interactionSrc = `assets/img/yukaEvent/interaction.png`;
  const lineSrc = `assets/img/yukaEvent/line.png`;
  const multipleSrc = `assets/img/yukaEvent/multiple.png`;

  const valuePromotionLink = `https://www.flaticon.com/free-icons/value`;
  const videoPromotionLink = `https://www.flaticon.com/free-icons/video`;
  const teacherPromotionLink = `https://www.flaticon.com/free-icons/teacher`;
  const conversationPromotionLink = `https://www.flaticon.com/free-icons/conversation`;
  const interactionPromotionLink = `https://www.flaticon.com/free-icons/interaction`;
  const linePromotionLink = `https://www.flaticon.com/free-icons/line`;
  const multiplePromotionLink = `https://www.flaticon.com/free-icons/multiple`;
</script>


<!-- ======= Plan Section ======= -->
<section class="yuka-app-plan gray-background">
  <div class="container">
    <div class="row content">
      <div class="col-lg-12 p-4 new-content-intro">
        <div class="col-sm-12 col-md-6 col-lg-6 offset-3 mb-3 new-contens-info-block">
          <h1 class="new-content-title">{$t("yukaEvent.appPlanTitle")}</h1>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 new-content-image-display">
        <div class="col-sm-12 col-md-12 col-lg-12">
          <div class="col-sm-12 col-md-4 col-lg-4 new-content-image mt-3 mb-3 yuka-plan-image">
            <a class="disabled-link" href={valuePromotionLink} title="value icons">
              <img class="about-image" src={valueSrc} alt="video">
            </a>
            <div class="col-sm-12 mt-1 mb-1 gray-text">
              <span>{$t("yukaEvent.appPlanIntro0_1")}</span>
              <span>{$t("yukaEvent.appPlanIntro0_2")}</span>
              <span>{$t("yukaEvent.appPlanIntro0_3")}</span>
              <span><b>{$t("yukaEvent.appPlanIntro0_4")}</b></span>
              <span>{$t("yukaEvent.appPlanIntro0_5")}</span>
            </div>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-4 new-content-image mt-3 mb-3 yuka-plan-image">
            <a class="disabled-link" href={videoPromotionLink} title="video icons">
              <img class="about-image" src={videoSrc} alt="video">
            </a>
            <div class="col-sm-12 mt-1 mb-1 gray-text">
              <span>{$t("yukaEvent.appPlanIntro1")}</span>
            </div>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-4 new-content-image mt-3 mb-3 yuka-plan-image">
            <a class="disabled-link" href={teacherPromotionLink} title="teacher icons">
              <img class="about-image" src={teacherSrc} alt="teacher">
            </a>
            <div class="col-sm-12 mt-1 mb-1 gray-text">
              <sapn>{$t("yukaEvent.appPlanIntro2")}</sapn>
            </div>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-4 new-content-image mt-3 mb-3 yuka-plan-image">
            <a class="disabled-link" href={conversationPromotionLink} title="conversation icons">
              <img class="about-image" src={conversationSrc} alt="conversation">
            </a>
            <div class="col-sm-12 mt-1 mb-1 gray-text">
              <sapn>{$t("yukaEvent.appPlanIntro3")}</sapn>
            </div>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-4 new-content-image mt-3 mb-3 yuka-plan-image">
            <a class="disabled-link" href={interactionPromotionLink} title="interaction icons">
              <img class="about-image" src={interactionSrc} alt="interaction">
            </a>
            <div class="col-sm-12 mt-1 mb-1 gray-text">
              <sapn>{$t("yukaEvent.appPlanIntro4")}</sapn>
            </div>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-4 new-content-image mt-3 mb-3 yuka-plan-image">
            <a class="disabled-link" href={linePromotionLink} title="line icons">
              <img class="about-image" src={lineSrc} alt="line">
            </a>
            <div class="col-sm-12 mt-1 mb-1 gray-text">
              <sapn>{$t("yukaEvent.appPlanIntro5")}</sapn>
            </div>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-4 new-content-image mt-3 mb-3 yuka-plan-image">
            <a class="disabled-link" href={multiplePromotionLink} title="line icons">
              <img class="about-image" src={multipleSrc} alt="line">
            </a>
            <div class="col-sm-12 mt-1 mb-1 gray-text">
              <sapn>{$t("yukaEvent.appPlanIntro6")}</sapn>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section><!-- End Plan Section -->